import { computed, defineComponent, watch } from 'vue';
import { Download } from '@element-plus/icons-vue';
import { validationRequired } from '@/core/helpers/validation';
export default defineComponent({
    components: { Download },
    props: {
        answerTypeId: String,
        scheme: {
            type: Object,
            default: () => {
                return {};
            }
        },
        statementFields: {
            type: Array,
            default: () => {
                return [];
            }
        },
        relevantEvidenceFields: {
            type: Array,
            default: () => {
                return [];
            }
        },
        competencyUnit: {
            type: Object,
            default: () => {
                return {};
            }
        },
        disabled: Boolean,
        isAssessment: Boolean,
        order: Number
    },
    emits: [
        'update:statementFields',
        'update:relevantEvidenceFields',
        'triggerCompleted'
    ],
    setup(props, { emit }) {
        const modelStatementFields = computed({
            get() {
                return props.statementFields;
            },
            set(value) {
                emit('update:statementFields', value);
            }
        });
        const modelRelevantEvidenceFields = computed({
            get() {
                return props.relevantEvidenceFields;
            },
            set(value) {
                emit('update:relevantEvidenceFields', value);
            }
        });
        const foundStatementIndex = (statementId, answerFieldId) => {
            const statementFields = modelStatementFields.value.findIndex((item) => {
                return item.statement.id === statementId;
            });
            const statementAnswerFields = modelStatementFields.value[statementFields].statementAnswerFields.findIndex((item) => {
                return item.formAnswerField.answerFieldId === answerFieldId;
            });
            return {
                statementFields,
                statementAnswerFields
            };
        };
        const findIndexRelevantEvidenceFields = (relevantEvidenceFields) => {
            const foundIndex = modelRelevantEvidenceFields.value.findIndex((item) => {
                return item.statementId === relevantEvidenceFields.statementId;
            });
            if (foundIndex >= 0)
                return foundIndex;
            return -1;
        };
        const checkCompleted = computed(() => {
            if (!props.isAssessment)
                return false;
            if (props.competencyUnit.statements.length &&
                props.competencyUnit.customAnswerFields.length) {
                return modelRelevantEvidenceFields.value
                    .map((item) => {
                    const check = (variable) => {
                        return variable !== null;
                    };
                    return (check(modelRelevantEvidenceFields.value[findIndexRelevantEvidenceFields(item)].isValid) &&
                        check(modelRelevantEvidenceFields.value[findIndexRelevantEvidenceFields(item)].isOriginal) &&
                        check(modelRelevantEvidenceFields.value[findIndexRelevantEvidenceFields(item)].isLatest) &&
                        check(modelRelevantEvidenceFields.value[findIndexRelevantEvidenceFields(item)].isWorthy));
                })
                    .every((parent) => {
                    return parent;
                });
            }
            return false;
        });
        watch(() => {
            return checkCompleted.value;
        }, (newValue) => {
            emit('triggerCompleted', newValue);
        }, { immediate: true, deep: true });
        return {
            validationRequired,
            modelStatementFields,
            modelRelevantEvidenceFields,
            foundStatementIndex,
            findIndexRelevantEvidenceFields
        };
    }
});
